import * as L from 'leaflet';
import 'leaflet.markercluster';

declare const mapDefaultCenter: { val: string } | null;

const onDisplayMap = (map: any) => { };

const onDisplayListing = (map: any) => { };

const createMap = (mapElement: HTMLElement, options: any): any => {
  const defaultCenter = mapDefaultCenter?.val.split(',') ?? [0, 0]
  const map = L.map(
    mapElement,
    options.mapOptions || {}
  ).setView(defaultCenter, options.zoom ?? 10);
  L.tileLayer(options.openStreetMapsUrl, {
    tileSize: 512,
    zoomOffset: -1,
    minZoom: 1,
    attribution:
      options.openStreetMapsAttribution != ""
        ? options.openStreetMapsAttribution
        : '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    crossOrigin: true,
  }).addTo(map);

  return map;
};

const placePropertyPins = (
  mapInstance: any,
  options: any,
  properties: any[],
  createMarker: (property: any) => any,
) => {
  let markers = L.featureGroup();
  if (options.cluster) {
    let clusterOptions = {};
    if (options.clusterOptions && options.clusterOptions.url) {
      clusterOptions = {
        iconCreateFunction: (cluster: any) => {
          return L.divIcon({
            html: `<div style="background-image: url(${options.clusterOptions.url}); background-size: contain; width: ${options.clusterOptions.width ?? 30}px; height: ${options.clusterOptions.height ?? 30}px; color: ${options.clusterOptions.textColor ?? "white"}; display: flex; justify-content: center;"><p class="">${cluster.getChildCount()}</p></div>`,
            iconAnchor: [
              options.clusterOptions.width ?? 30 / 2,
              options.clusterOptions.height ?? 30 / 2,
            ],
          });
        },
      };
    }
    markers = L.markerClusterGroup(clusterOptions);
  }

  properties.forEach((property: any) => {
    const marker = createMarker(property);
    markers.addLayer(marker);
  });

  if (properties.length > 0 && options.autoCenter != false) {
    mapInstance.fitBounds(markers.getBounds());
    if (properties.length == 1) {
      mapInstance.setZoom(15);
    }
  }

  mapInstance.addLayer(markers);
};

const addMarker = (
  mapInstance: any,
  options: any,
  property: any,
  position: any,
) => {
  let icon;

  switch (property.type) {
    case 'nearby':
      icon = L.icon({
        iconUrl: options.marker.url,
        iconSize: [options.marker.width, options.marker.height],
        iconAnchor: [options.marker.width / 2, options.marker.height],
      })
      break
    case 'current':
      icon = L.icon({
        iconUrl: "/wp-content/uploads/2025/09/locationmarker.svg",
        iconSize: [options.marker.width, options.marker.height],
        iconAnchor: [options.marker.width / 2, options.marker.height],
      })
      break
    case 'experience':
      icon = L.icon({
        iconUrl: "/wp-content/uploads/2025/09/experiencemarker.svg",
        iconSize: [options.marker.width, options.marker.height],
        iconAnchor: [options.marker.width / 2, options.marker.height],
      })
      break
    default:
      icon = L.icon({
        iconUrl: options.marker.url,
        iconSize: [options.marker.width, options.marker.height],
        iconAnchor: [options.marker.width / 2, options.marker.height],
      })
  }

  const marker = L.marker([position.lat, position.lng], {
    icon: icon,
    autoPanOnFocus: false,
    autoPan: false,
  }).bindPopup(property.description, {
    offset: [0, -options.marker.height + 10],
  });
  return marker;
};

const createCustomMarkerHTML = (options: any, count: number) => { };

const enableClustering = (
  mapInstance: any,
  options: any,
  container: HTMLElement,
  markers: any[],
) => { };

const onClusterClick = (
  event: any,
  clickedCluster: any,
  map: any,
  container: any,
) => { };

export default {
  onDisplayMap,
  onDisplayListing,
  createMap,
  placePropertyPins,
  addMarker,
  enableClustering,
};
